var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-menu',{attrs:{"offset-y":"","open-on-hover":""}},[_c('hg-account-button',{attrs:{"slot":"activator","hg-user":_vm.hgUser},slot:"activator"}),_c('hg-menu-list')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }